/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

// styles (Order is important! Bootstrap css has to be first!)
import 'bootstrap/dist/css/bootstrap.css';

import '@finbeat/react-toolkit/dist/index.css';
import './index.scss';

import {
    ActionsBtnProvider,
    ErrorProvider,
    Pending,
    ToastProvider,
    WorkplaceConfirm,
} from '@finbeat/react-toolkit';
import { defaultFormatter } from 'mappers/errorFormatters';
import { AuthProvider } from 'providers/AuthProvider';
import GeneralSettingsProvider from 'providers/GeneralSettingsProvider';
import NotifyProvider from 'providers/NotifyProvider';
import { Suspense } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './utils/i18n';

const container = document.getElementById('root');

if (container) {
    const root = ReactDOM.createRoot(container);
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                retry: false,
                refetchOnWindowFocus: false,
            },
        },
    });
    const publicUrl = process.env.PUBLIC_URL;

    root.render(
        <DndProvider backend={HTML5Backend}>
            <QueryClientProvider client={queryClient}>
                <ErrorProvider defaultFormatter={defaultFormatter}>
                    <AuthProvider>
                        <GeneralSettingsProvider fallback={<Pending />}>
                            <Suspense fallback={<Pending />}>
                                <ToastProvider>
                                    <NotifyProvider>
                                        <BrowserRouter basename={publicUrl}>
                                            <ActionsBtnProvider>
                                                <App />
                                                <WorkplaceConfirm />
                                            </ActionsBtnProvider>
                                        </BrowserRouter>
                                    </NotifyProvider>
                                </ToastProvider>
                            </Suspense>
                        </GeneralSettingsProvider>
                    </AuthProvider>
                </ErrorProvider>
                <ReactQueryDevtools initialIsOpen={false} position="top-right" />
            </QueryClientProvider>
        </DndProvider>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
} else {
    throw new Error('App root container not found!');
}
